// AUTO-GENERATED by scripts/gen-registry-meta.ts — do not edit by hand.
import type { HowToGuide } from "./registry";

export interface HowToMeta {
  slug: string;
  title: string;
  metaTitle: string;
  metaDesc: string;
  category: HowToGuide["category"];
  tldr: string;
  totalTimeLabel: string;
  estimatedCost?: HowToGuide["estimatedCost"];
  updatedAt: string;
  stepCount: number;
}

export const HOWTO_CATEGORY_LABEL: Record<HowToGuide["category"], string> = {
  "notary": "Notary Public",
  "translation": "การแปลเอกสาร",
  "legalization": "MFA / Apostille",
  "visa": "วีซ่า",
  "marriage": "การจดทะเบียนสมรส",
  "police": "Police Clearance"
};

export const HOWTO_META: HowToMeta[] = [
  {
    "slug": "how-to-notarize-document-thailand",
    "title": "วิธีรับรองเอกสารกับ Notary Public ในประเทศไทย — ทีละขั้น",
    "metaTitle": "วิธีรับรองเอกสาร Notary Public ในไทย 2026",
    "metaDesc": "คู่มือ 8 ขั้นตอนรับรองเอกสาร Notary Public ในไทยปี 2026 — เตรียมเอกสาร, จองนัด, ค่าบริการ 800-3,000 บาท, ส่ง MFA ต่อ พร้อมเคล็ดลับและตัวอย่างจากทีม Thai Notary",
    "category": "notary",
    "tldr": "ขั้นตอนสั้น: (1) เตรียมต้นฉบับ + บัตรประชาชน/พาสปอร์ต (2) ติดต่อ Notary (3) ลงนามต่อหน้าทนาย (4) รับเอกสารพร้อมตรา (5) ถ้าใช้ต่างประเทศต้องส่ง MFA ต่อ",
    "totalTimeLabel": "30 นาที – 1 ชั่วโมง",
    "estimatedCost": {
      "currency": "THB",
      "min": 800,
      "max": 3000
    },
    "updatedAt": "2026-06-11",
    "stepCount": 8
  },
  {
    "slug": "how-to-get-mfa-legalization-thailand",
    "title": "วิธีขอ MFA Legalization ที่กรมการกงสุล — ทีละขั้น",
    "metaTitle": "วิธีขอ MFA Legalization ในไทย 2026 — ทีละขั้น",
    "metaDesc": "คู่มือ 7 ขั้นยื่น MFA Legalization ที่กรมการกงสุล แจ้งวัฒนะ — เอกสาร, ค่าธรรมเนียม 400-800 บาท, เวลา 1-3 วันทำการ พร้อมเคล็ดลับและตัวอย่างจากทีม Thai Notary",
    "category": "legalization",
    "tldr": "(1) แปลภาษาอังกฤษโดยนักแปล MoJ (2) Notary ลงนาม (3) ยื่นกรมการกงสุล แจ้งวัฒนะ (4) เลือกบริการปกติ/ด่วน (5) รับเอกสาร (6) ส่งสถานทูตปลายทางต่อ",
    "totalTimeLabel": "1-3 วันทำการ",
    "estimatedCost": {
      "currency": "THB",
      "min": 400,
      "max": 800
    },
    "updatedAt": "2026-06-11",
    "stepCount": 7
  },
  {
    "slug": "how-to-apply-dtv-visa-thailand",
    "title": "วิธีสมัคร DTV Visa (Destination Thailand Visa) — ทีละขั้น",
    "metaTitle": "วิธีสมัคร DTV Visa ปี 2026 — คู่มือทีละขั้น",
    "metaDesc": "คู่มือสมัคร DTV Visa 5 ปีสำหรับ Digital Nomad — เอกสาร, statement 500,000 บาท, e-Visa Portal, ค่าธรรมเนียม 10,000 บาท พร้อมเคล็ดลับและตัวอย่างจากทีม Thai",
    "category": "visa",
    "tldr": "(1) เปิดบัญชี e-Visa (2) เตรียม statement 500k บาท (3) Proof of work remote (4) อัปโหลดเอกสาร (5) จ่าย 10,000 บาท (6) Visa ออก 2-4 สัปดาห์",
    "totalTimeLabel": "2-4 สัปดาห์",
    "estimatedCost": {
      "currency": "THB",
      "min": 10000,
      "max": 35000
    },
    "updatedAt": "2026-06-11",
    "stepCount": 8
  },
  {
    "slug": "how-to-get-naati-translation-thailand",
    "title": "วิธีขอแปล NAATI ในประเทศไทย — ทีละขั้น",
    "metaTitle": "วิธีขอแปล NAATI ในไทย 2026 — คู่มือทีละขั้น",
    "metaDesc": "คู่มือขอแปล NAATI สำหรับวีซ่าออสเตรเลีย — เลือกนักแปล CPN, ส่งไฟล์, รับ digital certificate, ค่าใช้จ่าย 600-2,500 บาท/หน้า",
    "category": "translation",
    "tldr": "(1) เลือกนักแปล NAATI CPN ตรวจหมายเลข (2) ส่งไฟล์สแกนคุณภาพสูง (3) ระบุภาษาเป้าหมาย (4) รับ digital certificate (5) บางกรณีต้องมีต้นฉบับลงนามสด",
    "totalTimeLabel": "1-3 วันทำการ",
    "estimatedCost": {
      "currency": "THB",
      "min": 600,
      "max": 2500
    },
    "updatedAt": "2026-06-11",
    "stepCount": 7
  },
  {
    "slug": "how-to-marry-foreigner-thailand",
    "title": "วิธีจดทะเบียนสมรสกับชาวต่างชาติในไทย — ทีละขั้น",
    "metaTitle": "วิธีจดทะเบียนสมรสกับชาวต่างชาติในไทย 2026",
    "metaDesc": "คู่มือจดทะเบียนสมรสกับชาวต่างชาติในไทย — Affirmation, แปล, MFA, ที่ว่าการอำเภอ, ค่าใช้จ่ายรวม 8,000-25,000 บาท พร้อมเคล็ดลับและตัวอย่างจากทีม Thai Notary Phuket",
    "category": "marriage",
    "tldr": "(1) คู่ต่างชาติขอ Affirmation of Freedom to Marry ที่สถานทูต (2) แปลภาษาไทยโดย MoJ translator (3) MFA Legalization (4) ทั้งคู่ไปที่ว่าการอำเภอ (5) รับใบสมรส คร.2",
    "totalTimeLabel": "1-2 สัปดาห์",
    "estimatedCost": {
      "currency": "THB",
      "min": 8000,
      "max": 25000
    },
    "updatedAt": "2026-06-11",
    "stepCount": 7
  },
  {
    "slug": "how-to-get-police-clearance-thailand",
    "title": "วิธีขอ Police Clearance Certificate ในประเทศไทย — ทีละขั้น",
    "metaTitle": "วิธีขอ Police Clearance ในไทย 2026 — คู่มือ",
    "metaDesc": "คู่มือขอ Police Clearance ที่สำนักงานตำรวจแห่งชาติ — เอกสาร, ลายนิ้วมือ, ค่าธรรมเนียม 100 บาท, ใช้เวลา 15-30 วันทำการ พร้อมเคล็ดลับและตัวอย่างจากทีม Thai",
    "category": "police",
    "tldr": "(1) เตรียมพาสปอร์ต + รูปถ่าย (2) ไปกองทะเบียน ปทุมวัน (3) พิมพ์ลายนิ้วมือ (4) จ่าย 100 บาท (5) รอ 15-30 วัน (6) แปล + MFA + สถานทูตปลายทาง",
    "totalTimeLabel": "15-30 วันทำการ",
    "estimatedCost": {
      "currency": "THB",
      "min": 100,
      "max": 5000
    },
    "updatedAt": "2026-06-11",
    "stepCount": 8
  }
];

export function getHowToMeta(slug: string): HowToMeta | undefined {
  return HOWTO_META.find((g) => g.slug === slug);
}
